import React from "react";

const ToastSuccess = ({ message }) => {
  return (
    <div className="flex h-[85px] items-center bg-green-50 relative w-[534px]">
      <div className="h-full bg-green-200 w-4" />
      <div className="flex items-center ml-4 pr-[50px]  w-full">
        <img src="/icons/success-toast.svg" alt="success" />
        <p className="text-gray-800 text-body-md ml-3">
          <span className="font-semibold">Success:</span> {message}
        </p>
      </div>
    </div>
  );
};

export default ToastSuccess;
